<template>
  <v-dialog persistent :value="show" width="580">
    <v-card class="pt-16 pb-4">
      <v-card-text class="ma-0 pa-0 text-center px-16">
        <p class="ma-0 pa-0 px-10 h6">
          {{ $t('rev.validation.hooray_validated') }}
        </p>
      </v-card-text>
      <v-card-actions class="ma-0 pa-0 justify-end mt-10 px-6">
        <Button
          plain
          color="grey"
          :text="$t('common.button.close')"
          @click="$emit('close')"
        />
        <Button
          color="primary"
          :text="$t('rev.validation.go_to_validations')"
          @click="$emit('goToValidationsView')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Button from '@/components/UI/Button'
import confetti from 'canvas-confetti'

export default {
  name: 'SuccessDialog',

  components: {
    Button,
  },

  props: {
    show: Boolean,
  },

  watch: {
    show(val) {
      if (val) {
        this.setCompleteAnimation()
      }
    },
  },

  methods: {
    setCompleteAnimation() {
      confetti({
        particleCount: 200,
        spread: 90,
        origin: { y: 0.55 },
        zIndex: 201,
      })
    },
  },
}
</script>
